<template>
  <div class="signature-dimensions">
    <template  v-for="(items, sId) in dimensions" v-if="sId === signatureId">
      <div class="item-wrap" v-for="(item, index) in items" :key="'sid' + index" @mouseenter="onPointEnter(item)" @mouseleave="onPointLeave(item)">
        <a href="#!" @click="close(sId, index, item)" class="close"><i class="fal fa-times"></i></a>
        <div class="item-content">
          <table>
            <tr><th>{{ 'Yükseklik:'|trans }} </th><td> {{ calcDimension(item).height }}</td></tr>
            <tr><th>{{ 'Genişlik:'|trans }} </th><td> {{ calcDimension(item).width }}</td></tr>
            <tr><th>{{ 'Zaman:'|trans }} </th><td> {{ calcDimension(item).time }}ms</td></tr>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import EventBus from "../Draw/eventBus";

export default {
  name: "SignatureDimension",
  props: ['dimensions', 'signatureId'],
  methods: {
    close(signatureId, index, item) {
      EventBus.$emit('onDimensionPointLeave' + this.signatureId, {'point': item})
      this.dimensions[signatureId].splice(index, 1)
    },
    calcDimension(point) {
      return {
        width: Math.round(Math.abs(point[0].d.x - point[1].d.x)),
        height: Math.round(Math.abs(point[0].d.y - point[1].d.y)),
        time: Math.round(Math.abs(point[0].d.time - point[1].d.time)),
      }
    },
    onPointEnter(item) {
      EventBus.$emit('onDimensionPointEnter' + this.signatureId, {'point': item})
    },
    onPointLeave(item) {
      EventBus.$emit('onDimensionPointLeave' + this.signatureId, {'point': item})
    },
  }
}
</script>

<style lang="scss" scoped>
.signature-dimensions {
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 170px;

  .item-wrap {
    position: relative;
    background: rgba(0, 0, 0, 0.5);
    color: #FFF;
    font-size: 14px;
    border-radius: .15rem;
    padding: .25rem .5rem;
    margin-bottom: .5rem;
    cursor: pointer;
    transition: .2s all;
    &:hover {
      background: rgba(0, 0, 0, 0.6);
      .close {
        background: #9f0505;
        opacity: .8;
      }
    }
  }

  .close {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 0;
    font-size: .8rem;
    background: #585858;
    color: #FFF;
    width: 18px;
    text-align: center;
    height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 .15rem 0 .15rem;
    transition: .15s all;
    opacity: 0;
    &:hover{
      opacity: 1 !important;
    }
  }
}
</style>
